// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_22qna","checkboxWrap":"_2UhCd"};